module.exports = __webpack_public_path__ + "static/media/lisbon.aa6617d2.png";